export enum DocLinkType {
    SHAREFILE = 'SHAREFILE',
}

export interface IDocLinkModel {
    id: number;
    title: string;
    link: string;
    type: DocLinkType;
}
